import React from "react";
import { Download } from "lucide-react";

interface DownloadCsvButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const DownloadCsvButton: React.FC<DownloadCsvButtonProps> = ({
  onClick,
  disabled,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
    >
      <Download className="h-4 w-4" />
      Download CSV
    </button>
  );
};

export default DownloadCsvButton;
